import React from 'react';

const userfeedItem = ({ currentUser, userfeed, hashedCompanyId }) => {
  if (!userfeed || !userfeed.user || !currentUser) {
    return null;
  }

  const userfeedsReplies = userfeed.valid_userfeeds_replies
    ? userfeed.valid_userfeeds_replies
    : [];
  const getUserName = userfeed => {
    let userName = '';
    if (userfeed) {
      if (userfeed.companies_user) {
        const isRealNameRequired =
          userfeed.companies_user.company.is_real_name_required;
        userName = isRealNameRequired
          ? userfeed.companies_user.view_full_name_disp
          : userfeed.companies_user.nickname;
      } else if (userfeed.user && userfeed.user.tunagate_id) {
        userName = userfeed.user.tunagate_id;
      }
    }

    return userName;
  };

  return (
    <div key={userfeed.id} className="col-12 mb-1 p-0">
      <div className="top-image-area d-block w-100 h-100 mh-100 font-weight-bold">
        <div
          style={{
            borderRadius: 3,
            backgroundImage: `url('${userfeed.image_url_medium}')`,
            backgroundColor: `${
              userfeed.image_url_medium.includes('tunagate.com/images/brown-')
                ? 'rgba(0,0,0,0)'
                : 'rgba(0,0,0,0.5)'
            }`,
            backgroundBlendMode: 'darken',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column'
          }}
        >
          <a
            className="border-0 p-3 px-0 text-fz-10px w-100"
            href={
              hashedCompanyId
                ? `/community/${hashedCompanyId}/userfeeds/${userfeed.id}`
                : `/userfeeds/${userfeed.id}`
            }
          >
            <div className="mt-0">
              <p
                className="text-fz-13px text-white text-fz-bold mb-1"
                style={{ textShadow: '0 0 5px #000' }}
              >
                {userfeed.body}
              </p>
            </div>
            {userfeed.countries_pref && (
              <div className="py-1 d-flex align-items-center">
                <i
                  className="icon icon-area"
                  style={{ filter: 'drop-shadow(0 0 2px #fff)' }}
                />
                <p
                  className="text-white mb-0"
                  style={{ textShadow: '0 0 5px #000' }}
                >
                  {userfeed.countries_pref.name}
                </p>
              </div>
            )}
            {userfeed.circle && (
              <div className="row mt-1">
                <div className="col-6 d-flex align-items-center">
                  <img
                    className="lazyload rounded-circle mr-2"
                    width="23"
                    height="23"
                    src={userfeed.circle.main_image_url}
                    style={{ border: '0.5px solid #fff' }}
                  />
                  <span className="text-white">{userfeed.circle.name}</span>
                </div>
              </div>
            )}
            <div className="row mt-1">
              <div className="col-6 d-flex align-items-center">
                <img
                  className="lazyload rounded-circle mr-2"
                  width="23"
                  src={userfeed.companies_user
                    ? (userfeed.companies_user ? userfeed.companies_user.avatar_thumb : '' ) 
                    : (userfeed.user ? userfeed.user.avatar_thumb : '')}
                  style={{ border: '0.5px solid #fff' }}
                />
                <p
                  className="text-white m-0 text-nowrap"
                  style={{ width: '50px', textShadow: '0 0 5px #000' }}
                >
                  @{getUserName(userfeed)}
                </p>
              </div>
              <div className="col-6 w-100 overflow-hidden d-flex justify-content-end">
                <img
                  className="lazyload rounded-circle"
                  style={{ marginLeft: 0, border: '0.5px solid #fff' }}
                  width="23"
                  src={userfeed.companies_user
                    ? (userfeed.companies_user ? userfeed.companies_user.avatar_thumb : '' ) 
                    : (userfeed.user ? userfeed.user.avatar_thumb : '')}
                />
                {Array.from(
                  // eslint-disable-next-line no-undef
                  new Set(
                    userfeedsReplies.map(reply => {
                      if (reply.companies_user && reply.companies_user.id !== userfeed.companies_user.id && reply.companies_user.avatar_thumb) {
                        return reply.companies_user.avatar_thumb;
                      } else if (reply.user && reply.user.id !== userfeed.user.id && reply.user.avatar_thumb) {
                        return reply.user.avatar_thumb;
                      }
                      return null;
                    })
                  )
                )
                  .filter(Boolean)
                  .slice(0, 4)
                  .map((uri, index) => {
                    return (
                      <img
                        key={index}
                        className="lazyload rounded-circle"
                        style={{ marginLeft: -5, border: '1px solid #fff' }}
                        width="23"
                        src={uri}
                      />
                    );
                  })}
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};

export default userfeedItem;
